import { intersection } from 'lodash';

export default (listPermissionOfUser = [], requestListPermission = []) => {
  //* neu khong du quyen return true
  return intersection(listPermissionOfUser, requestListPermission).sort().toString().replace(/[,]+/g,'') !== requestListPermission.sort().toString().replace(/[,]+/g,'');
};
